export default "__VITE_ASSET__B8Ia7YvW__"